import { produce } from 'immer'

export const asBuilder = <T>(factory: () => T) => {
  const builder = (recipe?: (base: T) => void): T => {
    const base = factory()
    return recipe ? produce(base, recipe) : base
  }
  return builder
}
